(function () {
  function initialize() {
    // 自动抓取标头导航区域
    var navContainer = document.querySelector('.header__inline-menu');
    var toggleBtn = document.getElementById('CustomMenuToggle');
    if (!navContainer || !toggleBtn) return;
    var items = Array.from(navContainer.querySelectorAll(':scope > ul > li'));
    var expanded = false;

    function updateDropdowns() {
      navContainer.querySelectorAll('header-menu > details[open] > .header__submenu').forEach(function (menu) {
        var top = menu.getBoundingClientRect().top;
        menu.style.setProperty('--category-menu-available-height', Math.max(0, window.innerHeight - top - 16) + 'px');
      });
    }

    function updateRows() {
      items.forEach(function (item) { item.hidden = false; });
      // 只有在屏幕宽度大于 990px (电脑端) 时，才添加折叠类名
      var desktop = window.innerWidth >= 990;
      navContainer.classList.toggle('header-menu-collapsible', desktop);
      var bounds = items.map(function (item) { return item.getBoundingClientRect(); });
      var firstTop = bounds.length ? bounds[0].top : 0;
      var cutoff = navContainer.getBoundingClientRect().top + 120;
      var hiddenRows = bounds.map(function (rect) { return rect.top > firstTop + 1 && rect.top >= cutoff - 1; });
      items.forEach(function (item, index) {
        // Hide category rows, not their container: dropdowns must escape the compact header.
        item.hidden = desktop && !expanded && hiddenRows[index];
        if (item.hidden) {
          if (item.contains(document.activeElement)) toggleBtn.focus();
          item.querySelectorAll('details[open]').forEach(function (details) { details.open = false; });
        }
      });
      navContainer.classList.toggle('is-expanded', expanded);
      toggleBtn.classList.toggle('is-expanded', expanded);
      toggleBtn.hidden = !desktop || !hiddenRows.some(Boolean);
      toggleBtn.setAttribute('aria-expanded', String(expanded));
      toggleBtn.setAttribute('aria-label', expanded ? 'Show fewer categories' : 'Show all categories');
      updateDropdowns();
    }

    // 监听窗口大小改变，动态添加或移除折叠类名
    window.addEventListener('resize', updateRows);
    window.addEventListener('scroll', updateDropdowns, { passive: true });
    navContainer.addEventListener('toggle', function () { requestAnimationFrame(updateDropdowns); }, true);
    navContainer.addEventListener('animationend', updateDropdowns);
    // 点击箭头触发展开/收起
    toggleBtn.addEventListener('click', function (event) {
      event.preventDefault();
      expanded = !expanded;
      updateRows();
    });
    updateRows();
    window.addEventListener('load', updateRows, { once: true });
    if (document.fonts) document.fonts.ready.then(updateRows);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
